import React, {useEffect, useState} from "react";
import { useSelector, useDispatch } from "react-redux";
import QcImpactAnalysisPage from "./qc-impact-analysis.page";
import { getLang } from "app/feature/constants";
import CreditReportingApi from "../../../../app/api/credit-reporting";
import { getQcImpactByMonth, getQcFailByProduct } from "../../redux/action";

export default function QcImpactAnalysisContainer() {
    const dispatch = useDispatch();
    const lang = useSelector((state) => state.constant.languages);

    // Get chart data from Redux store
    const qcImpactByMonthData = useSelector((state) => state.reporting.credit.qcImpactByMonthData);
    const qcFailByProductData = useSelector((state) => state.reporting.credit.qcFailByProductData);

    const [pagination, setPagination] = useState({
        page: 0,
        rowsPerPage: 25,
    });

    const [listingData, setListingData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [isError, setIsError] = useState(false);

    const fetchData = () => {
        setIsLoading(true);
        setIsError(false);
        CreditReportingApi.fetchQcEventHistory({
            start: pagination.page * pagination.rowsPerPage,
            length: pagination.rowsPerPage,
        }).then((response) => {
            setIsLoading(false);
            setListingData(response.data);
        }).catch(() => {
            setIsLoading(false);
            setIsError(true);
        });
    };

    const fetchChartData = () => {
        dispatch(getQcFailByProduct({}));
        dispatch(getQcImpactByMonth({}));
    };

    useEffect(() => {
        fetchChartData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pagination]);

    const translate = (text) => {
        return getLang(lang, text);
    };

    const handlePageChange = (page) => {
        setPagination((prev) => ({
            ...prev,
            page: page,
        }));
    };

    const handleRowsPerPageChange = (rowsPerPage) => {
        setPagination({
            page: 0,
            rowsPerPage: rowsPerPage,
        });
    };

    const handleExport = () => {
        // TODO: Implement export functionality
        console.log("Exporting QC Report...");
    };

    return (
        <QcImpactAnalysisPage
            translate={translate}
            listingData={listingData}
            pagination={pagination}
            onPageChange={handlePageChange}
            onRowsPerPageChange={handleRowsPerPageChange}
            isLoading={isLoading}
            isError={isError}
            handleReload={fetchData}
            onExport={handleExport}
            qcFailByProduct={qcFailByProductData}
            qcImpactByMonth={qcImpactByMonthData}
        />
    );
}
